import { createContext } from "react";
import { LocationInfo } from "../shipping/types";

export const LocationOptionsContext = createContext<LocationInfo[] | undefined>(
  undefined,
);
